module.exports = __webpack_public_path__ + "static/media/BillOpenIcon.f25d35b1.svg";